export const USER_LIST = "/user-list";
export const USER_DETAILS = "/user-detail";
export const TEST_MODULE = "/test-module";
// export const TEST_HISTORY = "/test-history";
export const TEST_HISTORY = "/test-history";
export const TUG_SIDE_INFO = "/tug-side-info";
export const TUG_FRONT_INFO = "/tug-front-info";
export const GAIT_AND_BALANCE_INFO = "/gait-and-balance-info";
export const ROM_INFO = "/rom-info";
export const LOCOMOTIVE_INFO = "/locomotive-info";
export const HOW_TO_TEST_TUG_FRONT = "/how-to-test-tug-front";
export const HOW_TO_TEST_TUG_SIDE = "/how-to-test-tug-side";
export const HOW_TO_TEST_GAIT_AND_BALANCE = "/how-to-test-gait-and-balance";
export const HOW_TO_TEST_LEFT_FLEXION = "/how-to-test-left-flexion";
export const HOW_TO_TEST_LEFT_EXTENSION = "/how-to-test-left-extension";
export const HOW_TO_TEST_RIGHT_FLEXION = "/how-to-test-right-flexion";
export const HOW_TO_TEST_RIGHT_EXTENSION = "/how-to-test-right-extension";
export const ROM_DETAILS = "/rom-details";
export const ROM_LEFT_FLEXION = "/rom-left-flexion";
export const ROM_LEFT_EXTENSION = "/rom-left-extension";
export const ROM_TEST_FLIP = "/rom-test-flip";
export const ROM_RIGHT_FLEXION = "/rom-right-flexion";
export const ROM_RIGHT_EXTENSION = "/rom-right-extension";
